__turbopack_context__.v({
  "arrayTextField": "clientRemove-module-scss-module__JvXmjW__arrayTextField",
  "buttons-container": "clientRemove-module-scss-module__JvXmjW__buttons-container",
  "cancel-button": "clientRemove-module-scss-module__JvXmjW__cancel-button",
  "content": "clientRemove-module-scss-module__JvXmjW__content",
  "content-container": "clientRemove-module-scss-module__JvXmjW__content-container",
  "edit-icon": "clientRemove-module-scss-module__JvXmjW__edit-icon",
  "edit-icon-error": "clientRemove-module-scss-module__JvXmjW__edit-icon-error",
  "fade-in-uboa5dm": "clientRemove-module-scss-module__JvXmjW__fade-in-uboa5dm",
  "fade-in-uboa5e8": "clientRemove-module-scss-module__JvXmjW__fade-in-uboa5e8",
  "fade-in-uboa5eg": "clientRemove-module-scss-module__JvXmjW__fade-in-uboa5eg",
  "header-with-button": "clientRemove-module-scss-module__JvXmjW__header-with-button",
  "main": "clientRemove-module-scss-module__JvXmjW__main",
  "modal-button": "clientRemove-module-scss-module__JvXmjW__modal-button",
  "modal-subtitle": "clientRemove-module-scss-module__JvXmjW__modal-subtitle",
  "modal-title": "clientRemove-module-scss-module__JvXmjW__modal-title",
  "navButton": "clientRemove-module-scss-module__JvXmjW__navButton",
  "phone-container": "clientRemove-module-scss-module__JvXmjW__phone-container",
  "radio-buttons-container": "clientRemove-module-scss-module__JvXmjW__radio-buttons-container",
  "radio-buttons-padding": "clientRemove-module-scss-module__JvXmjW__radio-buttons-padding",
  "section-content": "clientRemove-module-scss-module__JvXmjW__section-content",
  "section-title": "clientRemove-module-scss-module__JvXmjW__section-title",
  "status": "clientRemove-module-scss-module__JvXmjW__status",
  "success-container": "clientRemove-module-scss-module__JvXmjW__success-container",
  "text-field-disabled": "clientRemove-module-scss-module__JvXmjW__text-field-disabled",
  "title": "clientRemove-module-scss-module__JvXmjW__title",
  "title-container": "clientRemove-module-scss-module__JvXmjW__title-container",
});
